import { render, staticRenderFns } from "./OrderFabricReadyExtraProcessTypeTable.vue?vue&type=template&id=4d04d017&scoped=true&"
import script from "./OrderFabricReadyExtraProcessTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricReadyExtraProcessTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d04d017",
  null
  
)

export default component.exports